import React from 'react';
import { Helmet } from 'react-helmet';
import LoginForm from '../components/LoginForm';
import TestimonialCard from '../components/TestimonialCard';

const Login = () => {
    return (
        <>
            <Helmet>
                <title>Login</title>
            </Helmet>

            <div className="flex flex-col lg:flex-row min-h-screen">
                {/* Left side - Login form */}
                <div className="w-full lg:w-1/2 flex items-center justify-center overflow-x-hidden overflow-y-auto">
                    <div className="w-full max-w-md p-4 sm:p-6 mx-auto">
                        <div className="mb-8 sm:mb-12">
                            <img
                                src="/lovable-uploads/247331e0-4511-4f68-9da6-c61ceca9b3d4.png"
                                alt="Ding AI Logo"
                                className="h-[50px] w-[152px]"
                            />
                        </div>
                        <LoginForm />
                    </div>
                </div>

                {/* Right side - Background and testimonial - only show on larger screens */}
                <TestimonialCard className="mt-12" quote="" callToAction="VIDEO" />
            </div>
        </>
    );
};

export default Login;
